export default __webpack_public_path__ + "static/media/loader.31cb192f.svg";